<template>
  <div class="teacher-eva">
    <div class="table">
      <div class="tea-row" v-for="(item, index) in eva">
        <div class="left">
          <div class="userImg">
            <img :src="item.profile_picture || person"
                 @error="imgErr(index)"
                 alt="">
          </div>
          <div class="userInfo">
            <p>姓名：{{item.name}}</p>
            <p>手机号：{{item.mobile_phone}}</p>
          </div>
        </div>
        <div class="right">
          <el-button type="primary" v-if="item.has_record === 1"  @click="evaluateShow(item.teacher_id)">查看</el-button>
          <div class="download" v-if="item.has_eva === 1">
            <a v-if="item.tea_eva_url"
               :href="item.tea_eva_url"
               download="">
              <el-button type="primary">下载</el-button>
            </a>
            <p v-else>暂无文件</p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="detail-info-dia"
      title="助理讲师评价表"
      :visible.sync="ifDiaShow"
      :close-on-click-modal="false"
      width="800px"
      top="12vh"
    >
      <div class="scroll-wrap">
        <vue-scroll :ops="disScrollOpt" ref="vScroll">
          <teacher-evaluate-view v-if="ifDiaShow" :teacherId="teacherId" :cId="cId"/>
        </vue-scroll>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import person from "@/assets/images/person.png";
  import ops from "@/assets/js/vuescrollOption";
  export default {
    name: "teacher-eva",
    props: {
      eva: {
        type: Array,
        required: true,
        default: () => {
          return [
            {
              mobile_phone: "",
              name: "",
              profile_picture: "",
              tea_eva_url: "",
              teacher_id: "",
            }
          ];
        }
      }
    },
    components:{
      'teacher-evaluate-view' : () => import("@/components/score/components/teacher-evaluate-view")
    },
    data() {
      return {
        person,
        ifDiaShow:false,
        disScrollOpt: ops(true),
        teacherId:"",
        cId: this.$route.query.c_id
      };
    },
    methods: {
      imgErr(idx) {
        this.$set(this.eva[idx], "profile_picture", this.person);
      },
      evaluateShow (id) {
        this.ifDiaShow = true
        this.teacherId = id
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  .teacher-eva {
    .table {
      border: 1px solid $color_white;
      .tea-row {
        padding: 15px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid $color_white;
        &:last-child {
          border-bottom: none;
        }
        .left {
          display: flex;
          margin: 0 30px 0 0;
          .userImg {
            flex: 0 0 auto;
            display: flex;
            align-items: center;
            margin: 0 20px 0 0;
            img {
              width: 70px;
              height: 70px;
              border-radius: 50%;
            }
          }
          .userInfo {
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            font-size: $font_size_medium;
          }
        }
        .right {
          display: flex;
          justify-content: space-between;
          .download {
            a {
              display: block;
            }
          }
        }
      }
    }
    .scroll-wrap{
      display block
      height 630px
      overflow hidden
      position relative
      margin-right -20px
    }
  }
</style>
